"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=assert;function assert(condition,message){if(!condition)throw new Error("Assertion failed. "+message)}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/probe.gl/dist/lib/utils/assert.js
// module id = 453
// module chunks = 0